import getErrorMessage from './error-message';

export default {
  getErrorMessage,
};
